import React from 'react';
import TotalCount from  './totalCount';
import Eworkers from  './eworkers';
import ActionFlows from  './actionFlows';

function Dashboard(props){  
    return (
        <div>
            <TotalCount/>
            <Eworkers/>
            <ActionFlows/>
        </div>
    )
}

export default Dashboard;